export default "__VITE_ASSET__ChrID3Dw__"